export function createWalker(root: Node, predicate: (node: Node) => boolean) {
    const acceptNode = (node: Node) => {
        if (predicate(node)) {
            return NodeFilter.FILTER_ACCEPT;
        }

        return NodeFilter.FILTER_SKIP;
    };

    // В IE11 необходимо передать функцию, а не объект
    const safeFilter = acceptNode as unknown as NodeFilter;
    //@ts-expect-error
    safeFilter.acceptNode = acceptNode;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, safeFilter);

    return walker;
}
